import ExtraSiNo from './ExtraSiNo.js'
import * as Constants from '../constants.js'

// Igual que ExtraSiNo (mismo render, mismo componentDidMount), solo cambia el
// default inicial de "checks" a SI/NO/NO APLICA en vez de APROBADO/DESAPROBADO/NO APLICA.
class ExtraFormularioAsociado extends ExtraSiNo {
	constructor(props) {
    super(props);
    this.state = {
      checks: JSON.parse(JSON.stringify(Object.values(Constants.ESTADOS_FORMULARIO_ASOCIADO)))
    }
  }
}

export default ExtraFormularioAsociado;
